import { render, staticRenderFns } from "./secondStep.vue?vue&type=template&id=b18b63c4&scoped=true"
import script from "./secondStep.vue?vue&type=script&lang=js"
export * from "./secondStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b18b63c4",
  null
  
)

export default component.exports